// src/constants/CHARACTERS.ts

export interface Character {
    name: string;
    boon: string;
    bane: string;
    dndBeyondLink?: string; // Optional: Add D&D Beyond links later
  }
  
  export const CHARACTERS: Character[] = [
    {
      name: "Aurora Luna Wynterstarr",
      boon: "Out of respect for Aurora, fellow campus musicians will cover your expenses for one night per week at places where live music is common.",
      bane: "When there’s live music on campus, the lyrics always include rude sentiments directed toward you.",
    },
    {
      name: "Bhedum “Rampart” Sooviij",
      boon: "Rampart’s commanding presence rubs off, and when you’re trying to avoid campus security, your fellow students always help you lie low.",
      bane: "Library books you need inexplicably go missing at key times, especially those about history. As a result, you can’t pull all-nighters.",
    },
    {
      name: "Cadoras Damellawar",
      boon: "The esteem for Cadoras in live-action roleplaying circles extends to you. Guild members will share any information you wish to know about Aberrations, Monstrosities, and Oozes.",
      bane: "You are a pariah in the campus roleplaying scene. The worst monsters are named after you.",
    },
    {
      name: "Drazhomir Yarnask",
      boon: "Drazhomir writes you poetry, and the smile it puts on your face makes you likable to everyone on campus except the most stone-hearted.",
      bane: "Other students who work in the Biblioplex refuse to help you find any of the tomes you seek. Even the reference librarians are more cryptic.",
    },
    {
      name: "Grayson Wildemere",
      boon: "Whenever you want to buy something on campus, a few words from Grayson get you deals. There’s a 25 percent chance your purchase costs half as much.",
      bane: "Gossip columns proclaim exaggerated versions of your worst traits.",
    },
    {
      name: "Greta Gorunn",
      boon: "Whenever you need anything heavy moved, members of the Iron-Lifters Society show up to help you.",
      bane: "Heavy things show up in inconvenient places, such as in front of your dorm door.",
    },
    {
      name: "Javenesh Stoutclaw",
      boon: "Javenesh’s reputation as a tough guy follows you. If peers would be aggressive toward you, they quickly back down.",
      bane: "The servers at Bow’s End Tavern know you are no friend to Javenesh. At the slightest sign of trouble, they blame you and ask you to leave.",
    },
    {
      name: "Larine Arneza",
      boon: "Larine is an expert at creating stylized distractions. If you want to slip away unnoticed from anywhere on campus, Larine or her club members help you escape.",
      bane: "You are offered the worst tickets to performances, if any at all.",
    },
    {
      name: "Melwythorne",
      boon: "Melwythorne’s spirituality centers you. You can calm even the most frazzled of your peers and, if necessary, extract information as needed.",
      bane: "Members of the silkball club and the Student-Mages of Faith refuse to acknowledge your presence.",
    },
    {
      name: "Mina Lee",
      boon: "Mina loves sharing her vast repository of knowledge with you. If you seek obscure information that’s not secret, Mina researches it and reports her findings within a week.",
      bane: "Firejolt Café never has the ingredients in stock for the beverages you initially order, even if it’s a common drink.",
    },
    {
      name: "Nora Ann Wu",
      boon: "The faculty’s respect for Nora extends to you. You can expect straightforward answers when you ask a faculty member for basic information.",
      bane: "Few faculty care to help you with basic requests.",
    },
    {
      name: "Quentillius Antiphiun Melentor III",
      boon: "You have adopted Quentillius’s authoritative voice, and in dire situations, your peers obey you when you issue commands.",
      bane: "Whenever you perform as part of a production, a small crowd shows up and boos you specifically.",
    },
    {
      name: "Rosimyffenbip “Rosie” Wuzfeddlims",
      boon: "Rosie’s energy is contagious. Whenever you travel any significant distance, you can reach your destination in half the normal time.",
      bane: "Whenever you participate in sports on campus (except for big events, such as the Battle of Strixhaven), fouls are constantly called on you.",
    },
    {
      name: "Rubina Larkingdale",
      boon: "Rubina’s gravitas has rubbed off, and you can easily command an entire room’s attention. They hear your words favorably if you wish.",
      bane: "Whenever any band performs in public, its members stop and shake their heads in disapproval when they see you.",
    },
    {
      name: "Shuvadri Glintmantle",
      boon: "If you quickly need the help of your peers, they drop everything to assist you as a favor to Shuvadri.",
      bane: "Graffiti making rude allusions to you keeps appearing on campus, and it takes days to get cleaned.",
    },
    {
      name: "Tilana Kapule",
      boon: "Tilana loves helping analyze problems. When you go to her for advice, she suggests a helpful solution that you hadn’t considered.",
      bane: "The faculty don’t trust you or help you much, for rumor has it that Tilana has found you wanting.",
    },
    {
      name: "Urzmaktok Grojsh",
      boon: "No matter the subject, you can always find a partner to study with, whether it’s Urzmaktok or a classmate doing him a favor.",
      bane: "No one on campus who isn’t another player character will study with you. If you ask, most shrug decline, saying you’ll probably fail.",
    },
    {
      name: "Zanther Bowen",
      boon: "You enjoy a high social rank as a result of your association with Zanther. Most of your peers fall all over themselves to do you favors.",
      bane: "No one on campus invites you to parties or events, although your friends receive invitations.",
    },
  ];
  